const errorTypes = {
  manual: 'manual',
  general: 'general',
  validate: 'validate',
  terms: 'terms',
  maxLength: 'maxLength',
  minLength: 'minLength',
  backend: 'backend',
} as const;

export default errorTypes;
